import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useRef, useEffect, useState } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default function RangeFacet({ facet, isActive, setActive, handleClick }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]

    const dropdownRef = useRef(null)
    const [maxHeight, setMaxHeight] = useState("0px")

    useEffect(() => {
        if (dropdownRef.current) {
            setMaxHeight(isActive ? `${dropdownRef.current.scrollHeight}px` : "0px")
        }
    }, [isActive])

    return (
        <li class={`ns-sidebar-dropdown ${isActive ? "ns-active" : ""}`}>
            <span
                class="ns-anchor ns-relative ns-w-100 ns-border-box px-8 py-12 flex justify-between items-center gap-4 lg:px-0"
                onClick={() => setActive(!isActive)}
            >
                <span class="uppercase flex items-center text-13-120 lg:text-14-120">{facet.name}</span>
                {isSelected && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {1}
                    </span>
                )}
                <Icon name="arrow" class={`transition-all ease-jl duration-600 ${isActive ? 'rotate-180' : 'rotate-0'}`} />
            </span>

            <div
                ref={dropdownRef}
                class="ns-sidebar-submenu bg-white inset-x-0 lg:absolute lg:z-10 overflow-hidden transition-all duration-500 lg:top-[80px]"
                style={{ maxHeight }}
            >
                <div class="flex flex-col px-14 py-12 lg:px-12 text-13-120">
                    <div class="ns-d-flex ns-justify-content-between ns-font-4 flex gap-8">
                        <div class="flex-1">
                            <label for={`ns-${facet.id}-min`} class="ns-form-label">Min.</label>
                            <RangeInput
                                id={`ns-${facet.id}-min`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[0]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([value, range[1]])
                                }}
                            />
                        </div>
                        <div class="flex-1">
                            <label for={`ns-${facet.id}-max`} class="ns-form-label">Max.</label>
                            <RangeInput
                                id={`ns-${facet.id}-max`}
                                min={min}
                                max={max}
                                range={range}
                                value={range[1]}
                                onChange={e => {
                                    const value = parseFloat(e.currentTarget.value) || undefined
                                    updateRange([range[0], value])
                                }}
                            />
                        </div>
                    </div>

                    <div class="flex p-8">
                        <RangeSlider id={facet.id} />
                    </div>
                </div>
            </div>
        </li>
    )
}
